module.exports = __webpack_public_path__ + "img/success.43932188.svg";